import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';

import { setModal } from '../../actions/modal';
import { BRIEF, CONTRACT, DELIVERABLE_SET, DELIVERABLE_SUBMIT, SIGNED_CONTRACT } from '../../utils/static-configuration';

class Timeline extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      vertical: this.props.vertical,
      analyticsVisible: false,
    };
  }

  onShowModal = docType => () => {
    this.props.onSetModal(docType);
  };

  onToggleAnalytics = () => {
    this.setState({ analyticsVisible: !this.state.analyticsVisible });
  };

  render() {
    const {
      deliverableStatus,
      docsStatus,
      isUserTeamMember,
      setMainView,
      analyticsHack,
      myUserRole,
      campaignId
    } = this.props;

    const briefStateImages = {
      incomplete: isUserTeamMember ? <img src="/icons/incomplete.svg" alt="incomplete" /> : <img src="/icons/pending.svg" alt="pending" />,
      pending: <img src="/icons/added.svg" alt="added" />,
      complete: <img src="/icons/complete.svg" alt="complete" />,
    };

    const contractStateImages = {
      incomplete: isUserTeamMember || docsStatus.brief !== 'complete' ? <img src="/icons/incomplete.svg" alt="incomplete" /> : <img src="/icons/pending.svg" alt="pending" />,
      pending: <img src="/icons/added.svg" alt="added" />,
      complete: <img src="/icons/complete.svg" alt="complete" />,
    };

    const deliverableSetStateImages = {
      incomplete: isUserTeamMember || docsStatus.contract !== 'complete' ? <img src="/icons/incomplete.svg" alt="incomplete" /> : <img src="/icons/pending.svg" alt="pending" />,
      pending: <img src="/icons/arrow.svg" alt="arrow" />,
      complete: <img src="/icons/arrow-seagreen.svg" alt="complete" />,
    };

    const deliverableAddedStateImages = {
      incomplete: <img src="/icons/incomplete.svg" alt="incomplete" />,
      pending: isUserTeamMember || !deliverableStatus.set ? <img src="/icons/added.svg" alt="added" /> : <img src="/icons/incomplete.svg" alt="incomplete" />,
      complete: deliverableStatus.added === deliverableStatus.approved ? <img src="/icons/added-seagreen.svg" alt="complete" /> : <img src="/icons/added.svg" alt="added" />,
    };

    const deliverableApprovedStateImages = {
      incomplete: <img src="/icons/incomplete.svg" alt="incomplete" />,
      pending: isUserTeamMember || !deliverableStatus.added ? <img src="/icons/incomplete.svg" alt="incomplete" /> : <img src="/icons/pending.svg" alt="pending" />,
      complete: <img src="/icons/arrow-seagreen.svg" alt="complete" />,
    };

    return (
      <div>
        { this.state.vertical &&
            <div>
              <table className="timeline vertical">
                <tbody>
                  <tr>
                    <td className="fixed">
                      { briefStateImages[docsStatus.brief] }
                    </td>
                    <td>
                      <div className="timeline-item-wrapper">
                        <p className="bold">Brief </p>
                        { docsStatus.brief !== 'incomplete' &&
                          <button className="small" onClick={setMainView('brief')}>
                            view
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="line fixed">
                      <div className="timeline-line short" />
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td className="fixed">
                      { contractStateImages[docsStatus.contract] }
                    </td>
                    <td>
                      <div className="timeline-item-wrapper">
                        <p className="bold">Contract </p>
                        { docsStatus.contract === 'complete' &&
                          <button className="small" onClick={setMainView('contract')}>
                            view
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="line fixed">
                      <div className="timeline-line short" />
                    </td>
                    <td />
                  </tr>
                  <tr>
                    <td className="fixed">
                      {deliverableSetStateImages[deliverableStatus.setStatus]}
                    </td>
                    <td>
                      <p>
                        <div className="timeline-item-wrapper">
                          <p className="bold">Deliverables ({deliverableStatus.set})</p>
                          <button className="small" onClick={setMainView('deliverables')}>
                            view
                          </button>
                        </div>
                      </p>
                    </td>
                  </tr>
                  { deliverableStatus.set > 0 &&
                    <tr>
                      <td className="line fixed">
                        { deliverableStatus.approved > 0 && isUserTeamMember && <div className="timeline-line long" /> }
                      </td>
                      <td>
                        <div className="spacer small" />
                        <p className="small light">Added ({deliverableStatus.added})&nbsp;&nbsp;Approved ({deliverableStatus.approved})</p>
                      </td>
                    </tr>
                  }
                  { deliverableStatus.approved > 0 && isUserTeamMember &&
                    <tr>
                      <td className="fixed">
                        <img src="/icons/lightning-blue.svg" alt="live" />
                      </td>
                      <td>
                        <div className="timeline-item-wrapper">
                          <p className="bold">Live</p>
                          <button className="small" onClick={() => this.context.router.push(`/campaign/${campaignId}?analytics`)}>
                            view
                          </button>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
        }
        { !this.state.vertical &&

          <div className="timeline">

              <div className="item">
                { briefStateImages[docsStatus.brief] }
                <span>&nbsp;Brief&nbsp;</span>
              </div>

              <div className="item">
                { contractStateImages[docsStatus.contract] }
                <span>&nbsp;Contract&nbsp;</span>
              </div>
              <div className="item">
                { deliverableSetStateImages[deliverableStatus.setStatus] }
                <span>&nbsp;Deliverables&nbsp;</span>
              </div>

            </div>
          }
      </div>
    );
  }
}

Timeline.propTypes = {
  routeParams: React.PropTypes.object,
};

export function mapDispatchToProps(dispatch) {
  return {
    onSetModal: modalName => dispatch(setModal(modalName)),
    dispatch,
  };
}

export default connect(null, mapDispatchToProps)(Timeline);



/** WEBPACK FOOTER **
 ** ./src/components/timeline/index.js
 **/